import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  accountInfo: Yup.object().shape({
    first_name: Yup.string()
      .trim()
      .required("First name is required"),
    last_name: Yup.string()
      .trim()
      .required("Last name is required"),
    primary_email_address: Yup.string()
      .trim()
      .email("Enter a valid email")
      .required("Email is required"),
  }),
  selectedAchCard: Yup.lazy((value, options) => {
    const { parent } = options;
    if (parent.activePayment === "ach") {
      return Yup.mixed().required("AchCard number is required");
    }
    return Yup.mixed().notRequired();
  }),
  cardsDetails: Yup.lazy((value, options) => {
    const { parent } = options;
    if (
      parent.activePayment === "credit-card" &&
      !parent.selectedCard &&
      !parent.isStripe
    ) {
      return Yup.object().shape({
        zip: Yup.string().required("ZIP code is required"),
        cvc: Yup.string()
          .matches(/^\d+$/, "CVC must be numeric")
          .min(3, "CVC must be at least 3 digits")
          .max(4, "CVC must be at most 4 digits")
          .required("CVC is required"),
        card_number: Yup.string()
          .required("Card number is required")
          .matches(/^\d{13,19}$/, "Card number is not valid"),

        expMonth: Yup.lazy(() => {
          if (parent.addCard) {
            return Yup.string().required("Expiry is required");
          }
          return Yup.string().notRequired();
        }),
        expYear: Yup.lazy(() => {
          if (parent.addCard) {
            return Yup.string().required("Expiry is required");
          }
          return Yup.string().notRequired();
        }),
        expiry: Yup.lazy(() => {
          if (!parent.addCard) {
            return Yup.string().required("Expiry is required");
          }
          return Yup.string().notRequired();
        }),
      });
    }
    if (parent.activePayment === "credit-card") {
      return Yup.object().shape({
        zip: Yup.string().required("ZIP code is required"),
      });
    }
    return Yup.mixed().notRequired();
  }),
  selectedCard: Yup.lazy((value, options) => {
    const { parent } = options;
    if (
      parent.activePayment === "credit-card" &&
      parent?.listCards?.data?.length > 0 &&
      !parent?.addCard
    ) {
      return Yup.string().required("Card selection is required");
    }

    return Yup.mixed().notRequired();
  }),
  renewalOptions: Yup.mixed().required("Renewal Options is Required"),
  captchaValue: Yup.mixed().required("CaptchaValue is Required"),
});
